import dayjs from 'dayjs'

const state = {
  pntProfile: null,
}

const getters = {
}

const mutations = {
  setPntProfile (state, payload) {
    state.pntProfile = payload
  },
}

const actions = {
  profile ({ state, commit, rootState }, params = {}) {
    const prevYear = dayjs().year() - 1
    const requestParams = {
      dateStart: dayjs(`${prevYear}-01-01`).format('YYYY-MM-DD'),
      dateEnd: dayjs(`${prevYear}-12-31`).format('YYYY-MM-DD'),
      ...params,
    }

    return rootState.axios.get('/coin/v1frontend/jypoint/profile', { params: requestParams }).then(res => {
      commit('setPntProfile', res.data.model)
      return res
    })
  },
  exchangeCoupons ({ state, commit, rootState }, params) {
    return rootState.axios.post('/coin/v1frontend/jypoint/exchange-coupons', params)
  },
  ranking ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin-pub/ranking', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
